import { styled } from "@mui/system";
import { Link as RouterLink } from "react-router-dom";
import PlusIcon from "src/icons/portfolio/PlusIcon";
import TradeIcon from "src/icons/portfolio/TradeIcon";

export const Button = styled(RouterLink)(({ theme }) => ({
  display: "flex",
  padding: "4px 8px",
  color: "#FFF",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "4px",
  gap: "8px",
  background: theme.palette.primary.main,
  boxShadow: "0px 4px 16px 0px rgba(42, 95, 129, 0.30)",
  cursor: "pointer",
  textDecoration: "none",

  "&:hover": {
    backgroundColor: "#4E7086",
  },

  "&:focus": {
    backgroundColor: "#E8F6FF",
    color: "#002035",
  },

  "&:focus.svg": {
    color: "#002035",
  },
}));

interface BalanceButtonProps {
  type: string;
}
const BalanceButton = (props: BalanceButtonProps) => {
  const { type } = props;

  let path = "";
  let icon = <></>;
  let text = "";

  switch (type) {
    case "deposit":
      path = "/wallets/details";
      text = "Deposit";
      icon = <PlusIcon />;
      break;
    case "trade":
      path = "/trade";
      text = "Trade";
      icon = <TradeIcon />;
      break;
    // Add withdrawal path here when its time to activate the feature
    case "withdrawal":
      path = "";
      text = "Withdrawal";
      break;
    default:
      break;
  }
  return (
    <Button to={path}>
      {icon}
      {text}
    </Button>
  );
};

export default BalanceButton;
